const newsSources = {
    Italy : {
        url: 'https://www.repubblica.it/rss/homepage/rss2.0.xml',
        donationText: 'Dona per l\'emergenza',
        donationLink: 'https://italianonprofit.it/donazioni-coronavirus/'
    },
    Spain :  {
        url:'https://elpais.com/rss/tags/ultimas_noticias.xml',
        donationText: 'Donate for the emergency',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
    },
    France :  {
        url:'https://www.francetvinfo.fr/france.rss',
        donationLink: 'https://don.pasteur.fr/coronavirus?from=KIPW75&utm_source=KIPW75&utm_medium=preheader&utm_campaign=coronavirus',
        donationText: 'Faites un don'
    },
    UK :  {
        url:'http://feeds.bbci.co.uk/news/uk/rss.xml',
        fallbackName: 'United Kingdom',
        donationText: 'Donate for the emergency',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
    },
    "S. Korea" : {
        fallbackName: 'Korea, South',
        donationText: 'Donate for the emergency',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
    },
    USA: {
        fallbackName: 'US',
        donationText: 'Donate for the emergency',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
    },
    Default :  {
        url:'http://feeds.bbci.co.uk/news/world/rss.xml',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
        donationText: 'Donate for the emergency',
        fallbackName: 'notset'
    },
    Germany :  {
        url:'https://rss.dw.com/xml/rss-de-all',
        donationText: 'Donate for the emergency',
        donationLink: 'https://www.who.int/emergencies/diseases/novel-coronavirus-2019/donate',
    }
}

export default newsSources;